"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIconStrokeWidth = exports.getIconSize = void 0;
var DEFAULT_SIZE = "middle";
var getIconSize = function (size) {
    return ({
        "x-small": 12,
        small: 16,
        middle: 24,
        large: 48,
    }[size || DEFAULT_SIZE]);
};
exports.getIconSize = getIconSize;
var getIconStrokeWidth = function (size) {
    return ({
        "x-small": 1,
        small: 1.5,
        middle: 1,
        large: 1,
    }[size || DEFAULT_SIZE]);
};
exports.getIconStrokeWidth = getIconStrokeWidth;
